import RestManager from "Api/RestManager";
import {
  ENDPOINTS,
} from 'Constants/apiEndpoints';

function getProfile(resource) {
  const profile = {};
  return profile;
}


export const auth = {
  async verifyNumber(number) {
    const url = `${ENDPOINTS.AUTH.VERIFY_NUMBER}`;
    const body = {"phone": number};
    return RestManager.requestWithoutQueryParams(url, 'POST', body);
  },
  async verifyCode(code, verifyNumberId) {
    const url = `${ENDPOINTS.AUTH.VERIFY_CODE}`;
    const body = {"verify_id": verifyNumberId, code};
    return RestManager.requestWithoutQueryParams(url, 'POST', body);
  },
  async refreshAccessToken(aToken, rToken) {
    const url = `${ENDPOINTS.AUTH.REFRESH_TOKEN}`;
    const body = {"access_token": aToken, "refresh_token": rToken};
    return RestManager.requestWithoutQueryParams(url, 'POST', body);
  },
  async logout(aToken, rToken) {
    const url = `${ENDPOINTS.AUTH.LOGOUT}`;
    const body = {"access_token": aToken, "refresh_token": rToken};
    return RestManager.requestWithoutQueryParams(url, 'POST', body);
    return null;
  },

};

export const rest = {
  // Call API
  async getLatestCalls(listLimit, userNumber) {
    const url = `${process.env.VUE_APP_BACKEND_URL}${ENDPOINTS.API.callApi}?userNumber=${userNumber}&limit=${listLimit}`;
    return await RestManager.request(url);
  },
  async makeACall(feedNumber, userNumber) {
    const url = `${process.env.VUE_APP_BACKEND_URL}${ENDPOINTS.API.callApi}?userNumber=${userNumber}`;
    const bodyData = {feedNumber};
    return await RestManager.requestWithoutQueryParams(url, 'POST', bodyData);
  },
  async hangUpACall(callId, userNumber) {
    const bodyData = {state: 'completed'};
    console.log('CALL ID: ', callId)
    const url = `${process.env.VUE_APP_BACKEND_URL}${ENDPOINTS.API.callApi}/${callId}?userNumber=${userNumber}`;
    return await RestManager.requestWithoutQueryParams(url, 'PATCH', bodyData);
  },
  // Bridge API
  async searchBridgeByNumber(feedNumber) {
    const url = `${process.env.VUE_APP_BACKEND_URL}${ENDPOINTS.API.bridgeApi}?feedNumber=${feedNumber}`;
    return await RestManager.request(url);
  },
  async getAllBridges() {
    const url = `${process.env.VUE_APP_BACKEND_URL}${ENDPOINTS.API.bridgeApi}`;
    return await RestManager.request(url);
  },
  async hangUpABridge(feedNumber, params) {
    const bodyData = {...params};
    const url = `${process.env.VUE_APP_BACKEND_URL}${ENDPOINTS.API.bridgeApi}/${feedNumber}`;
    return await RestManager.requestWithoutQueryParams(url, 'PATCH', bodyData);
  },
  // Domain user API
  async getDomainUsers() {
    const url = `${process.env.VUE_APP_BACKEND_URL}${ENDPOINTS.API.domainUserApi}`;
    return await RestManager.request(url);
  },
  async saveUser({edit, user}) {
    let method = 'POST';
    if (edit) {
      method = 'PATCH'
    }
    const url = `${process.env.VUE_APP_BACKEND_URL}${ENDPOINTS.API.domainUserApi}`;
    return await RestManager.requestWithoutQueryParams(url, method, user);
  },
  async deleteUser(phone) {
    const url = `${process.env.VUE_APP_BACKEND_URL}${ENDPOINTS.API.domainUserApi}?phone=${phone}`;
    return await RestManager.requestWithoutQueryParams(url, 'DELETE');
  },

  // Destination API
  async getUserStatus() {
    const url = `${process.env.VUE_APP_BACKEND_URL}${ENDPOINTS.API.destinationApi}`;
    return await RestManager.request(url);
  },
  async getBridgeByFeedNumber(feedNumber) {
    const url = `${process.env.VUE_APP_BACKEND_URL}${ENDPOINTS.API.destinationApi}?feedNumber=${feedNumber}`;
    return await RestManager.request(url);
  },
  // Feed API
  async updateFeedDescription(feedNumber, body) {
    const url = `${process.env.VUE_APP_BACKEND_URL}${ENDPOINTS.API.feedApi}/${feedNumber}`;
    return await RestManager.requestWithoutQueryParams(url, 'PUT', body);
  },
};
